import { lazy } from "react";

export default [
  {
    exact: true,
    path: "/:customerName/certificate/queue/",
    component: lazy(
      () => import("src/views/arkadu/certificate/CertificateQueueIndex"),
    ),
  },
  {
    exact: true,
    path: "/:customerName/certificate/signers/",
    component: lazy(
      () => import("src/views/arkadu/certificate/SignerProfileIndex"),
    ),
  },
];
